// optimizationLogic.js
import * as math from 'mathjs';

const performMonteCarloOptimization = ({ numSimulations, gamma, selectedAssets, covarianceMatrix, returnsArray }) => {
    const numAssets = selectedAssets?.length || 0;
    // Validation
    console.log('The selected asset is', selectedAssets);
    if (!selectedAssets || selectedAssets.length < 2) {
        console.error("You need to select at least two assets.");
        return [];
    }

    let bestObjectiveValue = Infinity;
    let bestWeights = [];

    for (let i = 0; i < numSimulations; i++) {
        // Generate random weights
        let weights = Array.from({ length: numAssets }, () => Math.random());
        let sumWeights = weights.reduce((a, b) => a + b, 0);
        weights = weights.map(weight => weight / sumWeights); // Normalize weights

        // Calculate objective function value
        let variancePart = math.multiply(math.multiply(weights, covarianceMatrix), math.transpose(weights));
        let returnPart = math.multiply(weights, returnsArray);
        let objectiveValue = 0.5 * variancePart - gamma * returnPart;

        // Check if this is the best (minimum) objective value so far
        if (objectiveValue < bestObjectiveValue) {
            bestObjectiveValue = objectiveValue;
            bestWeights = weights;
        }
    }

    return bestWeights;
};

export default performMonteCarloOptimization;
